// extracted by mini-css-extract-plugin
module.exports = {"form":"form--GNH0t","form__title":"form__title--1CEom","form__buttons":"form__buttons--124ix","form__button":"form__button--3Mhi-"};